import { useRef } from "react";
import { getLabelSimNao } from "../../../../commons/utils";
import { ConsultaPadrao } from "../../../../components/ConsultaPadrao";
import { model_exercicio } from "../../../../models";
import { ExercicioCategoria } from "./ExercicioCategoria";
import { TbCategory } from "react-icons/tb";

export const Exercicio = () => {
    const refCategoria = useRef<any>(null);

    const columns = [
        { field: 'exercid', header: 'Código' },
        { field: 'exercdescricao', header: 'Descrição' },
        { field: 'exercinformapeso', header: 'Informa Peso', body: (e: any) => getLabelSimNao(e.exercinformapeso), style: { width: '150px' } },
        { field: 'exercinformarepeticao', header: 'Informa Repetição', body: (e: any) => getLabelSimNao(e.exercinformarepeticao), style: { width: '150px' } },
        { field: 'exercinformaflexibilidade', header: 'Informa Flexibilidade', body: (e: any) => getLabelSimNao(e.exercinformaflexibilidade), style: { width: '150px' } },
        { field: 'exercativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '7rem', width: '7rem' } }
    ];


    function functions(row: any) {
        return ([
            {
                label: 'Exercícios',
                click: () => refCategoria.current.openModal(row),
                icon: <TbCategory size={24} />,
                color: '#0589a0'
            }
        ])
    }

    return (
        <>
            <ConsultaPadrao model={model_exercicio} columns={columns} functions={functions} />
            <ExercicioCategoria ref={refCategoria} />
        </>
    )
}